import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import AdminSidebar from "../../layouts/AdminSidebar";
import AppConstants from "../../../appConstants";
import webServices from "../../../services/webServices";
import { authCall } from "../../../services";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartPopUp from "../ChartPopUp";
import RestaurantUserProfilePopup from "./RestaurantUserProfilePopup";

// Register necessary components with ChartJS
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
  layout: {},
};

const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
const endDate = moment().format("YYYY-MM-DD");

function AdminDashboard() {
  const [touchLocations, setTouchLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [chartType, setChartType] = useState("");
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [showUserProfile, setShowUserProfile] = useState(false);

  const [startDT, setStartDT] = useState(
    moment().subtract(6, "days").format("YYYY-MM-DD")
  );

  const [weekReveals, setWeekReveals] = useState([]);

  // daily click
  const [selectedMachineId, setSelectedMachineId] = useState(null);
  const [dailyClick, setDailyClick] = useState(null);
  const [dayOfWeekClick, setDayOfWeekClick] = useState(null);
  const [hourClick, setHourClick] = useState(null);
  const [dailyClickLoading, setDailyClickLoading] = useState(false);

  const [type, setType] = useState("");

  // For Bootstrap Model
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const resp = await authCall("kioskTouchCounts", {});
      let machineCounts = {};
      if (resp?.type === "success") {
        machineCounts = resp?.payload?.[0];
        setTouchLocations(resp?.payload);
        setLoading(false);
      }

      const machineId = machineCounts?.id;
      setSelectedMachineId(machineId);
      // day wise clicks
      dailyKioskClick(machineId, startDate, endDate);

      // day of week reveal clicks
      dayOfWeekKioskClick(machineId, startDate, endDate);

      // per hours reveal clicks
      perHourKioskClick(machineId, startDate, endDate);

      // week reveal clicks
      /*const resp5 = await authCall("getWeekReveals", {
        touchType: "Restaurant",
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate,
      });
      if (resp5?.type === "success") {
        setWeekReveals(resp5?.payload);
      }
        */
    }
    fetchData();
  }, []);

  // get daily kiosk click
  const dailyKioskClick = async (machineId, startDate, endDate) => {
    setDailyClickLoading(true);
    const resp2 = await authCall("getDailyKioskClick", {
      machineId,
      startDate,
      endDate,
    });
    if (resp2?.type === "success") {
      setDailyClick(resp2?.payload);
      setDailyClickLoading(false);
    }
  };

  // get day of week kiosk click
  const dayOfWeekKioskClick = async (machineId, startDate, endDate) => {
    setDailyClickLoading(true);
    const resp2 = await authCall("getDayOfWeekKioskClick", {
      machineId,
      startDate,
      endDate,
    });
    if (resp2?.type === "success") {
      setDayOfWeekClick(resp2?.payload);
    }
  };

  // get per hour kiosk click
  const perHourKioskClick = async (machineId, startDate, endDate) => {
    setDailyClickLoading(true);
    const resp2 = await authCall("getPerHoursKioskClick", {
      machineId,
      startDate,
      endDate,
    });
    if (resp2?.type === "success") {
      setHourClick(resp2?.payload);
    }
  };

  const filterChart = (title, Chart, chartData, type) => {
    setTitle(title);
    setShow(true);
    setChartType(Chart);
    setChartData(chartData);
    setType(type);
    const stdate =
      type === "day"
        ? moment().subtract(6, "days").format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD");
    setStartDT(stdate);
    console.log(stdate);
  };

  const handleChangeFiter = async (startDate, endDate, typ) => {
    if (typ === "day") {
      const resp = await authCall("getDailyKioskClick", {
        machineId: selectedMachineId,
        startDate,
        endDate,
      });
      if (resp?.type === "success") {
        setChartData(resp?.payload);
      }
    } else if (typ === "week") {
      const resp = await authCall("getDayOfWeekKioskClick", {
        machineId: selectedMachineId,
        startDate,
        endDate,
      });
      if (resp?.type === "success") {
        setChartData(resp?.payload);
      }
    } else {
      const resp = await authCall("getPerHoursKioskClick", {
        machineId: selectedMachineId,
        startDate,
        endDate,
      });
      if (resp?.type === "success") {
        setChartData(resp?.payload);
      }
    }
  };

  const closeUserProfile = () => {
    setShowUserProfile(false);
  };

  const handleClickVenueLocation = (machineId) => {
    setSelectedMachineId(machineId);
    // day wise clicks
    dailyKioskClick(machineId, startDate, endDate);

    // day of week reveal clicks
    dayOfWeekKioskClick(machineId, startDate, endDate);

    // per hours reveal clicks
    perHourKioskClick(machineId, startDate, endDate);
  };

  return (
    <>
      <div className="dashboard-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title lh-1">Dashboard:</div>
                <div className="details-wrapper pt-3">
                  <div className="sub-title lh-sm mb-3 mb-lg-4">
                    Below you will see how your listing is preforming:
                  </div>

                  <div className="row pb-3">
                    <div className="col-lg-5">
                      <div className="chart-wrapper mb-4">
                        <div className="chart-cover p-3">
                          <div className="fw-medium mb-1">Number of Clicks</div>
                          {!dailyClick && (
                            <div
                              style={{
                                height: "136px",
                                width: "273px",
                                padding: "50px",
                                textAlign: "center",
                              }}
                            >
                              Loading...
                            </div>
                          )}
                          {dailyClick && (
                            <Line data={dailyClick} options={options} />
                          )}
                        </div>
                        <div className="btn-wrapper text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-custom"
                            onClick={() =>
                              filterChart(
                                "Number of Clicks",
                                Line,
                                dailyClick,
                                "day"
                              )
                            }
                          >
                            Select
                          </button>
                        </div>
                      </div>
                      <div className="chart-wrapper mb-4">
                        <div className="chart-cover p-3">
                          <div className="fw-medium mb-1">
                            Clicks By Days Of The Week
                          </div>
                          {!dayOfWeekClick && (
                            <div
                              style={{
                                height: "136px",
                                width: "273px",
                                padding: "50px",
                                textAlign: "center",
                              }}
                            >
                              Loading...
                            </div>
                          )}
                          {dayOfWeekClick && (
                            <Bar data={dayOfWeekClick} options={options} />
                          )}
                        </div>
                        <div className="btn-wrapper text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-custom"
                            onClick={() =>
                              filterChart(
                                "Clicks By Days Of The Week",
                                Bar,
                                dayOfWeekClick,
                                "week"
                              )
                            }
                          >
                            Select
                          </button>
                        </div>
                      </div>
                      <div className="chart-wrapper mb-4">
                        <div className="chart-cover p-3">
                          <div className="fw-medium mb-1">
                            Clicks By Hour Of The Day
                          </div>
                          {!hourClick && (
                            <div
                              style={{
                                height: "136px",
                                width: "273px",
                                padding: "50px",
                                textAlign: "center",
                              }}
                            >
                              Loading...
                            </div>
                          )}
                          {hourClick && (
                            <Bar data={hourClick} options={options} />
                          )}
                        </div>
                        <div className="btn-wrapper text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-custom"
                            onClick={() =>
                              filterChart(
                                "Clicks By Hour Of The Day",
                                Bar,
                                hourClick,
                                "hour"
                              )
                            }
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* VENUE AND LOCATION */}
                    <div className="col-lg-7 mb-4 mb-lg-0">
                      <div
                        className="table-responsive rounded-3"
                        style={{ border: "2px solid var(--theme-color1)" }}
                      >
                        <table
                          className="table theade-bg table-bordered m-0"
                          style={{ border: 0 }}
                        >
                          <thead>
                            <tr>
                              <th className="fs-md-18">Location</th>
                              <th className="fs-md-18 text-center">Clicks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {touchLocations.map((el, index) => (
                              <tr key={index} onClick={() => handleClickVenueLocation(el.id)} className="cursor-pointer">
                                <td>
                                  <div className="name fw-semibold">
                                    {el?.vanue_name}
                                  </div>
                                  <div className="fs-14">
                                    {el?.street_address}, {el?.city},{" "}
                                    {el?.state} {el?.post_code}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs-md-18 count fw-semibold text-center">
                                    {el.total_interactions}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="btn-wrapper text-center mt-4 d-none">
                        <Link to={AppConstants.routes.admin.runAdd}>
                          <button type="button" className="btn btn-custom">
                            Run An Add
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* HIDE */}
                  <div className="table-responsive table-bordered rounded-3 m-0 d-none">
                    <table className="table table-bordered m-0">
                      <thead>
                        <tr>
                          <th colSpan="2" className="fs-md-18 text-center">
                            Days 1<sup className="fw-medium">st</sup> - 7
                            <sup className="fw-medium">th</sup>
                          </th>
                          <th colSpan="2" className="fs-md-18 text-center">
                            Days 8<sup className="fw-medium">th</sup> - 15
                            <sup className="fw-medium">th</sup>
                          </th>
                          <th colSpan="2" className="fs-md-18 text-center">
                            Days 15<sup className="fw-medium">th</sup> - 23
                            <sup className="fw-medium">rd</sup>
                          </th>
                          <th colSpan="2" className="fs-md-18 text-center">
                            Days 24<sup className="fw-medium">th</sup> - 30
                            <sup className="fw-medium">th</sup>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {weekReveals.map((el, index) => (
                            <>
                              <td key={index}>Clicks</td>
                              <td>{el.total}</td>
                            </>
                          ))}
                        </tr>
                        <tr>
                          {weekReveals.map((el, index) => (
                            <>
                              <td key={index}>Amount</td>
                              <td>$ {(el.total * 0.1).toFixed(2)}</td>
                            </>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChartPopUp
        handleClose={handleClose}
        modalStatus={show}
        title={title}
        type={type}
        Chart={chartType}
        data={chartData}
        options={options}
        handleChangeFiter={handleChangeFiter}
        startDt={startDT}
        endDt={endDate}
      />
      <RestaurantUserProfilePopup
        show={showUserProfile}
        handleClose={closeUserProfile}
      />
    </>
  );
}

export default AdminDashboard;
